import dayjs from 'dayjs';

import type {ScheduleItem} from '../../types';

import {ProgramScheduleItemTypeEnum} from '../../../../../../utils/entity/program';
import {ScheduleItemRepeat} from '../../utils';

export class ScheduleItemModel {
  item: ScheduleItem;

  constructor(item: ScheduleItem) {
    this.item = item;
  }

  get repeat() {
    let result = '';

    if (this.item.repeat.days) {
      result =
        [
          ScheduleItemRepeat.DAILY!,
          ScheduleItemRepeat.WEEKLY!,
          ScheduleItemRepeat.BI_WEEKLY!,
          ScheduleItemRepeat.MONTHLY!,
        ]
          .find(repeat => repeat.interval === this.item.repeat.days)
          ?.toString() || '';
    }

    return result;
  }

  get time() {
    const startDate = dayjs().startOf('day').add(this.item.time, 'seconds');

    if (this.item.type.id === ProgramScheduleItemTypeEnum.CONFERENCE.id) {
      return `${startDate.format('LT')} - ${startDate
        .add(this.item.duration, 'seconds')
        .format('LT')}`;
    }

    return startDate.format('LT');
  }

  get title() {
    return this.item.title;
  }

  get type() {
    return this.item.type.id;
  }
}
